export const LOCALE_CHANGED = "env::locale::change";
export const MODAL_OPEN = "env::modal::open";
export const MODAL_CLOSE = "env::modal::close";
export const APP_INIT = "env::app::init";
export const UPDATE_USER = "env::user::update";